import React, { useState } from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import FactoryImage from '../factory.png';
import { BuildingsFill } from 'react-bootstrap-icons';
import { useAuth } from "../AuthProvider";
import { useTranslation } from 'react-i18next';
import { ADMIN, GAME_MASTER } from '../Roles';
import { useFormik } from 'formik';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import * as Yup from 'yup';
import HoverHelp from './HoverHelp';

const TeamCard = ({ team }) => {
    return (
        <Card style={{ position: 'relative' }}>
            <div
                style={{
                    backgroundImage: `url(${FactoryImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 0,
                }}
            />
            <div
                style={{
                    backgroundColor: 'rgba(0, 80, 20, 0.9)',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1,
                }}
            />
            <Card.Body className="text-light d-flex justify-content-center align-items-center" style={{ position: 'relative', zIndex: 2 }}>
                <Card.Title className="d-flex align-items-center fs-4">
                    <BuildingsFill className="me-2" />
                    {team.name}
                </Card.Title>
            </Card.Body>
        </Card>
    );
};

const DeleteMemberButton = ({ onClick }) => {
    const { t } = useTranslation();
    return (
        <Button variant="warning" onClick={onClick}>
            {t('teams.delete-member')}
        </Button>
    );
};

const Members = ({ index, members, formik, setSaved }) => {
    const { t } = useTranslation();
    const handleMemberNameChange = (idx, e) => {
        setSaved(false);
        const name = e.target.value;
        const teams = [...formik.values.teams];
        teams[index].members[idx].name = name;
        formik.setFieldValue('teams', teams);
    };
    const handleMemberEmailChange = (idx, e) => {
      setSaved(false);
      formik.setFieldValue(
        `teams[${index}].members[${idx}].email`,
        e.target.value
      );
    };
    const addMember = () => {
      setSaved(false);
      const newTeams = formik.values.teams.map((team, teamIndex) => {
        if (teamIndex !== index) return team;
        return {
          ...team,
          members: [
            ...(team.members || []),
            { name: '', email: '' }
          ]
        };
      });
      formik.setFieldValue('teams', newTeams);
    };
    const deleteMember = (idx) => {
        setSaved(false);
        const teams = [...formik.values.teams];
        teams[index].members.splice(idx, 1);
        formik.setFieldValue('teams', teams);
    };

    return (
        <Form.Group className="mb-3">
            <Table key={index} className="single-border-table">
                <tbody>
                    <tr>
                        <td>
                            {
                               members.map((member, i) => <Form.Group key={i} className="mb-3 d-flex align-items-center">
                                  <Form.Control
                                    type="text"
                                    placeholder={t('teams.member-name')}
                                    value={member.name}
                                    onChange={(e) => handleMemberNameChange(i, e)}
                                    onBlur={() => formik.setFieldTouched(`teams[${index}].members[${i}]`)}
                                    isInvalid={formik.touched.teams && Array.isArray(formik.errors.teams) && !!formik.errors.teams?.[index]}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.teams?.[index]}
                                  </Form.Control.Feedback>
                                  <Form.Control
                                    type="text"
                                    placeholder={t('teams.member-email')}
                                    value={member.email || ''}
                                    onChange={(e) => handleMemberEmailChange(i, e)}
                                    onBlur={() => formik.setFieldTouched(`teams[${index}].members[${i}]`)}
                                    isInvalid={formik.touched.teams && Array.isArray(formik.errors.teams) && !!formik.errors.teams?.[index]?.members?.[i]?.email}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.teams?.[index]}
                                  </Form.Control.Feedback>
                                  <DeleteMemberButton onClick={() => deleteMember(i)} />
                               </Form.Group>)
                            }
                            <Form.Control.Feedback type="invalid">
                               {formik.errors?.teams}
                            </Form.Control.Feedback>
                            <Button variant="secondary" onClick={addMember}>
                              {t('teams.add-member')}
                            </Button>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </Form.Group>
    );
};

const DeleteButton = ({ onClick }) => {
    const { t } = useTranslation();
    return (
        <Button variant="warning" onClick={onClick}>
            {t('teams.delete')}
        </Button>
    );
};

const TeamName = ({ index, formik, setSaved }) => {
    const { t } = useTranslation();
    const handleTeamNameChange = (e) => {
        setSaved(false);
        const name = e.target.value;
        const teams = [...formik.values.teams];
        teams[index].name = name;
        formik.setFieldValue('teams', teams);
    };

    return (
        <Form.Group className="mb-3">
            <Table key={index} className="single-border-table">
                <tbody>
                    <tr>
                        <td>
                            <Form.Control
                              type="text"
                              placeholder={t('teams.name')}
                              value={formik.values.teams[index].name}
                              onChange={(e) => handleTeamNameChange(e)}
                              onBlur={() => formik.setFieldTouched(`teams[${index}].name`)}
                              isInvalid={formik.touched.teams && Array.isArray(formik.errors.teams) && !!formik.errors.teams?.[index]}
                            />
                            <Form.Control.Feedback type="invalid">
                              {formik.errors.teams?.[index].name}
                            </Form.Control.Feedback>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </Form.Group>
    );
};

const TeamPassword = ({ index, formik }) => {
    const { t } = useTranslation();

    return (
        <Form.Group className="mb-3">
            <Table key={index} className="single-border-table">
                <tbody>
                    <tr>
                        <td>
                            <Form.Control
                              type="text"
                              disabled
                              value={formik.values.teams[index].password}
                            />
                        </td>
                        <td>
                            <HoverHelp id="team-password" text={t('passwords.help.team-password')} />
                        </td>
                    </tr>
                </tbody>
            </Table>
        </Form.Group>
    );
};

const MAX_PLAYERS_PER_TEAM = 10;

const hasText = (value) => typeof value === 'string' && value.trim().length > 0;

const hasValidMember = (team) => {
  return (team.members || []).some(member => hasText(member.name) && hasText(member.email));
};

const canStartTeams = (teams) => {
  return (teams || []).every(team => team.automaton || hasValidMember(team));
};

const validationSchema = Yup.object({
  playersPerTeam: Yup.number()
    .required('Number of players per team is required')
    .min(1, 'Number of players per team must be at least 1')
    .max(MAX_PLAYERS_PER_TEAM, 'Maximum of 10 players per team'),
  teams: Yup.array()
    .test(
        'unique-names',
        'Team names must be unique',
        (teams) => {
          if (!teams) return true;
          const names = teams
            .map(t => t.name)
            .filter(Boolean);
          return names.length === new Set(names).size;
        }
      )
    .test(
      'min-teams',
      'At least two teams',
      (teams) => {
        if (!teams) return false;
        return teams.length >= 2;
      }
    )
    .test(
      'max-members',
      'More team members than allowed',
      function (teams) {
        const { playersPerTeam } = this.parent;
        const faulty = teams.find(t => (t.members || []).length > playersPerTeam);
        return !faulty;
      }
    )
    .test(
      'non-automaton-members',
      'Every non-automaton team must have at least one member',
      canStartTeams
    )
});

const MAX_TEAMS = 7;

const AdminGameSetup = ({ game, reloadGame }) => {
    const auth = useAuth();
    const { t } = useTranslation();
    const [updating, setUpdating] = useState(false);
    const [starting, setStarting] = useState(false);
    const [saved, setSaved] = useState(true);
    const [error, setError] = useState();
    const formik = useFormik({
      initialValues: {
        teams: game?.teams || [],
        playersPerTeam: game?.playersPerTeam || 4,
      },
      validationSchema: validationSchema,
      onSubmit: values => {
          const data = {
              teams: values.teams,
              playersPerTeam: values.playersPerTeam,
          };
         axios.put(`/api/games/${game.id}/teams`, data, {
               headers: {
                 Authorization: `Bearer ${auth.token}`,
                 'Content-Type': 'application/json'
               },
             })
           .then(response => {
               setSaved(true);
               setUpdating(false);
           })
           .catch(error => {
               console.log(error);
           });
      },
    });

    const addTeam = () => {
        setSaved(false);
        const currentTeamCount = formik.values.teams.length;
        formik.setFieldValue('teams', [
          ...formik.values.teams,
          {
            name: `Team ${currentTeamCount + 1}`,
            password: "",
            members: [],
          }
        ]);
    };

    const addAutomatonTeam = () => {
        setSaved(false);
        const currentTeamCount = formik.values.teams.length;
        formik.setFieldValue('teams', [
          ...formik.values.teams,
          {
            name: `Automaton ${currentTeamCount + 1}`,
            password: null,
            members: [],
            automaton: true,
          }
        ]);
    };

    const deleteTeam = (index) => {
        setSaved(false);
        const teams = [...formik.values.teams];
        teams.splice(index, 1);
        formik.setFieldValue('teams', teams);
    };

    const startGame = () => {
        setStarting(true);
        axios.put(`/api/games/${game.id}`, {}, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
          params: {
              status: "ROUND_ACTIVE"
          },
        })
          .then(response => {
            const data = response.data;
            setStarting(false);
            reloadGame(data.id);
          })
          .catch(error => {
            console.log(error);
            setError(error);
            setStarting(false);
          });
    };

    const handlePlayersPerTeamChanged = (e) => {
        setSaved(false);
        const playersPerTeam = e.target.value;
        formik.setFieldValue('playersPerTeam', playersPerTeam);
    };

    if (error) return <p>{t('game.loading-error')}: {error.message}</p>;

    return <>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="g-3">
                <Col xs={12} sm={8} md={6} lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t('games.password')}</Form.Label>
                    <HoverHelp id="game-password" text={t('passwords.help.game-password')} />
                    <Form.Control
                      type="text"
                      disabled
                      value={game.password}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>{t('games.master-password')}</Form.Label>
                    <HoverHelp id="game-master-password" text={t('passwords.help.game-master-password')} />
                    <Form.Control
                      type="text"
                      disabled
                      value={game.masterPassword}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>{t('games.max-players-per-team')}</Form.Label>
                    <Form.Control
                      id="playersPerTeam"
                      type="text"
                      value={formik.values.playersPerTeam}
                      onChange={handlePlayersPerTeamChanged}
                      onBlur={formik.handleBlur}
                      isInvalid={formik.touched.playersPerTeam && !!formik.errors.playersPerTeam}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.playersPerTeam}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              {game.teams.length === 0 && <div>{t('teams.no-teams')}</div>}
              <Row className="g-3">
                {formik.values.teams.map((team, i) => (
                  <Col key={i} xs={12} sm={8} md={6} lg={3}>
                    <Card style={{ width: '100%' }} className="text-center">
                         <TeamCard team={team} />
                         <Card.Body>
                         <TeamName index={i} formik={formik} setSaved={setSaved} />
                         {team.automaton
                            ? <div className="mb-3 fw-bold">{t('teams.automaton')}</div>
                            : <>
                                <TeamPassword index={i} formik={formik} />
                                <Members index={i} members={team.members || []} formik={formik} setSaved={setSaved} />
                              </>
                         }
                         <DeleteButton onClick={() => deleteTeam(i)} />
                     </Card.Body>
                    </Card>
                  </Col>
                ))}
                <Form.Group className="mb-3">
                  {formik.touched.teams && typeof formik.errors.teams === 'string' && (
                    <div className="invalid-feedback d-block">
                      {formik.errors.teams}
                    </div>
                  )}
                </Form.Group>
              </Row>
             {(auth.roles.includes(ADMIN) || auth.roles.includes(GAME_MASTER)) &&
               <Row className="g-3">
                   <div className="mt-4">
                     <Button variant="secondary" onClick={addTeam} disabled={updating || formik.values.teams.length >= MAX_TEAMS}>
                     {t('teams.create')}
                     </Button>
                     <Button variant="secondary" onClick={addAutomatonTeam} disabled={updating || formik.values.teams.length >= MAX_TEAMS} className="ms-2">
                     {t('teams.create-automaton')}
                     </Button>
                   </div>
                   <div>
                       <Button type="submit" variant="primary" disabled={!(formik.isValid && formik.dirty)} className="me-2">{t('common.save')}</Button>
                       <Button onClick={startGame} variant="primary" disabled={!saved || starting || updating || !formik.isValid || !canStartTeams(formik.values.teams)}>{t('game.start')}</Button>
                   </div>
               </Row>
             }
            </Form>
    </>;
};

export default AdminGameSetup;
